import React, {  ReactElement } from 'react'
import * as app from "../services/AppService";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import TooltipElm from 'react-bootstrap/Tooltip';
import { RowItem } from '../models/Core/row-item';
import { InterfaceComponentsProps } from '../models/Core/componentsCore';
import { useSelector } from "react-redux";

export interface ButtonProps extends RowItem, Omit<InterfaceComponentsProps, "LabelClass"> {
    elmKey?: string | number;
    type?: "submit" | "reset" | "button" | undefined;
    clicked: (key: string) => void;
    rounded?: string;
    children?: ReactElement | ReactElement[];
    iconSize?: string;
    formID?: string;
    tooltip?: string;
    mt?: boolean;
    iconClass?: string;
    centraleBtn?: boolean
    faIcon?: string
    faSize?: string
}

export default function Button(props: ButtonProps) {

    const showBtns = useSelector((store: any) => store.showBtns);
    function getRingClass(className: string = ""): string {
        if (className.includes("btn-danger") || className.includes("outline-danger") || className.includes("bg-danger")) return "ring-danger";
        if (className.includes("btn-success") || className.includes("outline-success") || className.includes("bg-success")) return "ring-success";
        if (className.includes("btn-warning") || className.includes("outline-warning") || className.includes("bg-warning")) return "ring-warning";
        if (className.includes("btn-info") || className.includes("outline-info") || className.includes("bg-info")) return "ring-info";
        if (className.includes("btn-secondary") || className.includes("outline-secondary") || className.includes("bg-secondary")) return "ring-secondary";
        if (className.includes("bg-light-subtle") || className.includes("btn-light") || className.includes("bg-light")) return "ring-light";
        if (className.includes("bg-dark")) return "ring-dark";
        return "ring-primary";
    }
    function clicked(e: any) {
        if (props.clicked) props.clicked((props.elmKey || "").toString())
        e.currentTarget.blur(); //الخروج من الزر بعد الضغط عليه
    }
    const isLoginButton = props.label === "LogIn"; 
    const ringClass = getRingClass(props.class); 
    let btn = (<button type={props.type} className={`btn btn-sm shadow-hover ${ringClass} ${!isLoginButton ? "height-31" : ""} fw-normal focus-ring rounded-${props.rounded} d-inline-flex align-items-center justify-content-center flex-grow-1 flex-md-grow-0
    ${props.mt ? " mt-2 mt-md-4 mt-xxl-5 " : ""}
    ${props.label && (props.icon || props.faIcon) ? " gap-2 " : ""}  
      ${props.class}
         ${(props.icon !== "" && props.rounded !== "circle" ? "px-2" : " ")}`}
        onClick={clicked}
        form={props.formID}
        id={props.id ? props.id : "btn" + props.label}
        data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Tooltip on top" disabled={props.disabled} >
        <span className={`${(props.icon !== "" ? "" : " ")} ${props.labelClass} fs-6`}>{app.translate(props.label)}</span>
        {props.children}
        {props.icon && <span className={`fs-${props.iconSize} ${props.iconClass} iconssc-${props.icon}`}> </span>}
        {props.faIcon && <span className={`${props.faIcon} fs-${props.faSize}` }></span>}
    </button>);
    if (props.centraleBtn && !showBtns) return null;
    return (app.getBoolean(props.hide) ? <></> :
        !props.tooltip || props.disabled ? btn :
            <OverlayTrigger key={props.elmKey + 'bottom'} placement='bottom'
                overlay={
                    <TooltipElm style={{ position: "fixed" }} id={`tooltip-bottom`}>
                        {app.translate(props.tooltip)}
                    </TooltipElm>
                }>
                {btn}
            </OverlayTrigger>
    );
}

Button.defaultProps = {
    elmKey: "",
    type: "button",
    clicked: () => { },
    rounded: "1",
    icon: "",
    id: "",
    iconSize: "6",
    hide: false,
    tooltip: "",
    disabled: false,
    label: "",
    class: "btn-primary shadow-sm ",
    children: undefined,
    labelClass: "fs-6"
   
}

